(function () {

  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .controller('AgendamentoRelatorioEleitoral', AgendamentoRelatorioEleitoral);

  function AgendamentoRelatorioEleitoral(PeriodoService, AgendamentoService, $uibModal, DataService) {

    var vm = this;

    vm.init = init;
    vm.confirmarAgendamento = confirmarAgendamento;
    vm.convertDate = convertDate;
    vm.convertDateFullDate = convertDateFullDate;
    vm.confirmarExclusao = confirmarExclusao;
    vm.agendamentosRealizados = [];

    vm.init();

    function init() {
      vm.periodos = PeriodoService.loadPeriodosFiltro('desc');
      vm.periodoSelecionado = vm.periodos[0];
      AgendamentoService.listarAgendamentosCorrente().then((result) => {
         vm.agendamentosRealizados = result;
      });
      vm.today = moment();
    }

    function convertDate(date) {
      return DataService.convertDate(date);
    }

    function convertDateFullDate(number) {
      return DataService.convertDateFullDate(number);
    }

    function confirmarAgendamento() {
      return $uibModal.open({
        templateUrl:"module/corregedoria/relatorioEleitoral/agendamento/agendamento.confirmacao.html",
        controller: 'ModalInstanceConfirmacaoAgendamento',
        controllerAs: 'vm',
        resolve: {
          periodoSelecionado: () => {
            return { periodo:vm.periodoSelecionado, periodoExtenso:convertDate(vm.periodoSelecionado) };
          }
        }
      }).result
      .then(() => {
        AgendamentoService.listarAgendamentosCorrente().then((result) => {
           vm.agendamentosRealizados = result;
        });
      });
    }

    function confirmarExclusao(idAgendamento) {
      return $uibModal.open({
        templateUrl:"module/corregedoria/relatorioEleitoral/agendamento/agendamento.exclusao.confirmacao.html",
        controller: 'ModalInstanceExclusaoAgendamento',
        controllerAs: 'vm',
        resolve: {
          parametros: () => {
            return { periodo:vm.periodoSelecionado, periodoExtenso:convertDate(vm.periodoSelecionado), idAgendamento:idAgendamento };
          }
        }
      }).result
      .then(() => {
        AgendamentoService.listarAgendamentosCorrente().then((result) => {
           vm.agendamentosRealizados = result;
        });
      });
    }
  }

})();
